import React from 'react';
import {BodyMediumBold} from '@spaced-out/ui-design-system/lib/components/Text';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {EmptyState} from '@spaced-out/ui-design-system/lib/components/EmptyState';
import type {NotificationType} from './types';
import {NotificationItem} from './notification-item';
import css from './notification-section.css';


const NotificationSection = ({
  displayNotifications,
  removeNotification,
}: {
  displayNotifications: Record<
    'today' | 'yesterday' | 'earlier',
    NotificationType[]
  >;
  removeNotification: Boolean;
}) => {
  const {t} = useLabelTranslation();
  const {today, yesterday, earlier} = displayNotifications;

  if (today.length === 0 && yesterday.length === 0 && earlier.length === 0) {
    return (
      <EmptyState
        title={t('No_Notification_yet', 'No Notification yet')}
        description={t(
          'All_clear_for_now_Keep_an_eye_out',
          'All clear for now. Keep an eye out!',
        )}
        imageVariant="data"
      />
    );
  }
  return (
    <div className={css.notificationSection}>
      {today.length > 0 && (
        <BodyMediumBold className={css.sectionTitle}>
          {t('Today', 'Today')}
        </BodyMediumBold>
      )}
      {today.map((notification) => (
        <NotificationItem
          notification={notification}
          key={notification.id}
          removeNotification={removeNotification}
        />
      ))}
      {yesterday.length > 0 && (
        <BodyMediumBold className={css.sectionTitle}>
          {t('Yesterday', 'Yesterday')}
        </BodyMediumBold>
      )}
      {yesterday.map((notification) => (
        <NotificationItem
          notification={notification}
          key={notification.id}
          removeNotification={removeNotification}
        />
      ))}
      {earlier.length > 0 && (
        <BodyMediumBold className={css.sectionTitle}>
          {t('Earlier', 'Earlier')}
        </BodyMediumBold>
      )}
      {earlier.map((notification) => (
        <NotificationItem
          notification={notification}
          key={notification.id}
          removeNotification={removeNotification}
        />
      ))}
    </div>
  );
};

export default NotificationSection;
